import initialState from './initialState';
import * as types from '../actions/actionTypes';

export function outlookItem(state = initialState.outlookItem, action) {

    let newState;
  switch (action.type) {
    case types.ITEMTYPE_RECEIVE:
        newState = {
            ...state,
            type: action.outlookType,
            readOnly: action.readOnly
        } 
        return newState;
        
    case types.ITEMLOCATION_RECIEVE:
        newState = {
            ...state,
            location: action.location
        } 
        return newState;
      
    case types.ITEM_SENDER_RECIEVE:
    case types.ITEM_TO_RECIPIENTS_RECIEVE:
    case types.ITEM_CC_RECIPIENTS_RECIEVE:   
    case types.ITEM_BCC_RECIPIENTS_RECIEVE:  {
        
        const unique = a => [...new Set(a)];

        newState = { ...state };
        newState.recipients = {
            byEmail: [ ...state.recipients.byEmail],
            byHash: {
                ...state.recipients.byHash,
              }
        }


        action.recipients.map(r => 
            newState.recipients = {
                byEmail: unique([ ...newState.recipients.byEmail, r.emailAddress]),
                byHash: {
                    ...newState.recipients.byHash,
                    [r.emailAddress]: r
                  }
            }
        );
        return newState;
    }

    default:
      return state;
  }
}


const getAllRecipients = (state) => state.recipients.byEmail.map(email => state.recipients.byHash[email]);

export const getRecipients= (state) => {
  return getAllRecipients(state);
};